import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {useAuth} from "./services/AuthProvider";
import {ThemeProvider} from "@mui/material";
import theme from "./theme";
import './App.css';

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import Home from './pages/Home/Home';
import AdminTable from "./pages/AdminPortal/AdminTable";
import Login from "./pages/Login/Login";
import MoodQuiz from './pages/MoodQuiz/MoodQuiz';
import StartGame from "./pages/StartGame/StartGame";
import AccountSettings from "./pages/AccountSettings/AccountSettings";
import AccountDeleted from "./pages/AccountSettings/AccountDeletedFeedback";
import Activate from "./pages/Register/Activate";
import Register from "./pages/Register/Register";
import CheckYourEmail from "./pages/ForgotPassword/CheckYourEmail";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import PageNotFound from "./pages/ErrorPages/PageNotFound";
import StartSPARX from "./pages/StartGame/StartSPARX";
import SetNewPassword from "./pages/ForgotPassword/SetNewPassword";
import LoginRequiredPage from "./pages/ErrorPages/LoginRequiredPage";
import UnsubscribeEmail from "./pages/AccountSettings/unsubscribeEmail";

interface PrivateRouteProps {
  component: React.ComponentType<any>;
  allowedRoles: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, allowedRoles, ...rest }) => {
  const { isLoggedIn, userProfile } = useAuth();

  if (!isLoggedIn || !userProfile || !userProfile.role) {
    return <LoginRequiredPage />;
  }

  if (allowedRoles.includes(userProfile.role)) {
    return <Component {...rest} />;
  } else {
    return <Navigate to="/" />;
  }
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="AppContainer">
        <header>
          <Header />
        </header>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="account-deleted" element={<AccountDeleted />} />
            <Route path="activate" element={<Activate />} />
            <Route path="admin" element={<PrivateRoute component={AdminTable} allowedRoles={['admin']} />}/>
            <Route path="check_my_mood" element={<MoodQuiz />} />
            <Route path="check_your_email" element={<CheckYourEmail />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="profile" element={<AccountSettings />} />
            <Route path="set-new-password" element={<SetNewPassword />} />
            <Route path="start-the-game" element={<PrivateRoute component={StartGame} allowedRoles={['sparx_user']} />}/>
            <Route path="startsparx" element={<PrivateRoute component={StartSPARX} allowedRoles={['sparx_user']} />}/>
            <Route path="unsubscribe" element={<UnsubscribeEmail />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
        <footer>
          <Footer />
        </footer>
      </div>
    </ThemeProvider>
  );
}

export default App;
